module.exports = __webpack_public_path__ + "static/media/Foodipedia.fee416e1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Foodipedia.svg
// module id = 509
// module chunks = 11